<template>
<div class="contentGlobal">
    <el-row >
        <el-col :span="6">
            <el-table
            :data="devices.filter(data => !search || parseInt(data.id) === parseInt(search))"
            stripe
            height="600"
            style="width: 100%">
                <el-table-column
                    sortable
                    prop="id"
                    label="ID"
                    width="120">
                </el-table-column>
                <el-table-column
                    sortable
                    size="mini"
                    :formatter="cellDateFormater"
                    prop="createdAt"
                    label="Insert date"
                    width="165">
                </el-table-column>
                <el-table-column
                    align="right">
                    <template slot="header" slot-scope="scope">
                        <el-input
                        v-model="search"
                        size="mini"
                        placeholder="Type to search"/>
                    </template>
                    <template slot-scope="scope">
                        <el-button size="mini" @click="onViewLogs(scope.$index, scope.row)">View</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-col>
      
        <el-col :span="16">
            <el-row>
                 <el-col :span="24">
                    <el-table
                        :data="logs"
                        stripe
                        height="400"
                        style="width: 100%">
                            <el-table-column
                                label="Type"
                                width="120">
                                <template slot-scope="scope">
                                    <icon v-if="scope.row.type === 'POST'" name="arrow-alt-circle-right" class="green"></icon>
                                    <icon v-else name="arrow-alt-circle-left" class="red"></icon>
                                    <span style="margin-left: 10px">{{ scope.row.type }}</span>
                                </template>
                            </el-table-column>
                         <el-table-column
                                sortable
                                :formatter="cellDateFormater"
                                prop="timestamp"
                                label="Date"
                                width="190">
                            </el-table-column>
                            <el-table-column
                                prop="payload"
                                label="Payload"
                                max-width="600">
                            </el-table-column>
                        </el-table>
                 </el-col>
                
                 <el-col :span="24">
                    <p>Config device <strong>{{selectedDevice.id }}</strong></p>
                    <el-form ref="form" label-width="120px" size="mini">
                        <el-form-item label="Type A">
                            <el-input v-model="selectedDevice.fieldA" :disabled="!selectedDevice.id"></el-input>
                        </el-form-item>
                        <el-form-item label="Type B">
                            <el-input v-model="selectedDevice.fieldB" :disabled="!selectedDevice.id"></el-input>
                        </el-form-item>
                    <el-button @click="onUpdate" :disabled="!selectedDevice.id">Update values</el-button>
                    </el-form>
                  </el-col>
            </el-row>
        </el-col>
    </el-row>
    
</div>
</template>

<script>
import { mapState} from 'vuex'
import BeatLoader from 'vue-spinner/src/BeatLoader.vue'


export default {
    name: 'dashboard',
    components:{ 
        BeatLoader
    },
    data() {
        return {
            search: '',
            isLoading:false,
            selectedDevice: {}
        }
    },
    mounted() {
         this.$nextTick(() => {
            this.getDevices()
            this.isLoading = true
        })   
    },
    watch: {
        'devices': {
            handler(value) {
             value.forEach ( (device) => {
                if(this.selectedDevice && this.selectedDevice.id === device.id){
                    this.selectedDevice = device
                }
             }) 
            }
        },
    },
    computed: {
        ...mapState(['currentUser', 'devices', 'logs']),

    },

    methods: {
        getDevices() {
            this.$store.dispatch('getDevices');
        }, 

        cellDateFormater(row, column, cellValue, index){
            let date = this.$moment.unix(cellValue).utc().format();
            let val = this.$moment.utc(date).local().format('DD-MM-YYYY HH:mm:ss');
      
            return val
        },
        onViewLogs(index, row){
            this.selectedDevice = this.devices.find( (device) => {
                return device.id === row.id
            })
            this.$store.dispatch('getLogs', { id: row.id}).then(response => {
                if(response){
                 this.logs = response;
                }else{
                     console.log('no results found');
                }
            }, error => {
                console.log(error);
            })
        },
        onUpdate() {
            this.$snotify.async('Updating device', 'Sending data', () => new Promise((resolve, reject) => {
                this.$store.dispatch('updateDevice', {
                    'id': this.selectedDevice.id,
                    'fields':{
                        'fieldA': this.selectedDevice.fieldA, 
                        'fieldB': this.selectedDevice.fieldB
                    }

                }).then(response => {
                   resolve({
                        title: 'success!',
                        config: {
                            timeout: 1000,
                            closeOnClick: true
                        }
                    })

                }, error => {
                    reject({
                        title: 'Error updating device',
                        body: error,
                        config: {
                            timeout: 3000,
                            closeOnClick: true
                        }
                    })
                });
            }))
        },
    }
}
</script>

<style>
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
    margin-left: 15px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

  .green {
    color:green
  }
    
.red {
    color:red
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard.vue